import { ChangeEvent, FormEvent, useContext, useState } from "react"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Card } from "primereact/card"
import commonStyles from "../common.module.css"
import { useAuthResetPassword } from "../../api/queries/useAuthResetPassword"
import Logo from "../common/Logo"
import styles from "./styles.module.css"
import globalToastContext from "../../context/globalToast"
import { useNavigate } from "react-router"
import FieldError, { FormErrors } from "../FieldError"
import { AuthResetPasswordPayload } from "../../api/types/auth"
import { ResponseData } from "../../api/types/base"

export default function ResetPassword() {
  const { ref } = useContext(globalToastContext)
  const navigate = useNavigate()
  const resetPassword = useAuthResetPassword()

  const [email, setEmail] = useState<string>("")
  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => setEmail(event.target.value)

  const [errors, setErrors] = useState<FormErrors<AuthResetPasswordPayload>>()

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    try {
      await resetPassword.mutateAsync({ email })

      ref?.current?.show({
        severity: "info",
        summary: "Na váš e-mail byly odeslány další instrukce pro změnu hesla."
      })

      navigate("/")
    } catch (err: any) {
      const response: ResponseData = err.response.data
      const newErrors: FormErrors<AuthResetPasswordPayload> = {}

      response.errors.forEach((error) => {
        newErrors[error.property as keyof AuthResetPasswordPayload] = error.message
      })

      setErrors(newErrors)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card title={""} className={styles.card}>
        <Logo />

        <h2>Zapomenuté heslo</h2>

        <div className={"p-fluid"}>
          <div className={"field"}>
            <label className={commonStyles.labelRequired}>E-mail:</label>
            <InputText required={true} value={email} onChange={handleEmailChange} />
            <FieldError error={errors?.email} />
          </div>
        </div>

        <div className={"text-center"}>
          <Button label={"Odeslat"} disabled={!email || resetPassword.isLoading}
            icon={"pi pi-send"} />
        </div>
      </Card>
    </form>
  )
}
